import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'
import { useAppContext } from '../redux/slices/appContext'
import { QUERY_KEYS } from './queryKeys'

export const useLevelThings = (levelTypeId, levelId) => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: ['get-level-things', userId, levelTypeId, levelId],
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-things', {
        levelTypeId,
        levelId
      })

      return data
    }
  })
}

export const useGetThingSchema = (levelTypeId, options = {}) => {
  const { enabled = true, mapper } = options
  return useQuery({
    enabled,
    queryKey: ['levels', QUERY_KEYS.getThingSchema, levelTypeId],
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-thing-schema', {
        levelTypeId
      })
      return data
    },
    select: mapper
  })
}
export const useGetThingSchemas = (levelTypeIds, options = {}) => {
  const { enabled = true, mapper } = options
  return useQuery({
    enabled,
    queryKey: ['levels', QUERY_KEYS.getThingSchemas],
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-thing-schemas', {
        levelTypeIds: levelTypeIds
      })
      return data
    },
    select: mapper
  })
}

export const useModifyContentSchema = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const { data } = await postNamedCommand('levels', 'modify-thing-schema', command)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['levels', QUERY_KEYS.getThingSchemas],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useSetThingContent = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ levelTypeId, levelId, code, content, ordinal }) => {
      const { data } = await postNamedCommand('levels', 'set-thing-content', {
        levelTypeId, levelId, code, content, ordinal
      })

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get-level-things'], refetchType: 'all' }).catch(console.error)
    }
  })
}

export const useCreateThingConfiguration = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ levelTypeId, code, name, description, category, configuration }) => {
      const { data } = await postNamedCommand('levels', 'create-thing-configuration', {
        levelTypeId, code, name, description, category, configuration
      })

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['levels', QUERY_KEYS.getThingSchemas],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useDeleteThingConfiguration = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ thingConfigurationId }) => {
      const { data } = await postNamedCommand('levels', 'modify-thing-configuration', {
        thingConfigurationId
      })

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['levels', QUERY_KEYS.getThingSchemas],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useThingConfigurationCategories = () => {
  return useQuery({
    queryKey: ['get-thing-configuration-categories'],
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-thing-configuration-categories', {})

      return data
    }
  })
}

export const useGetThingCodesInUse = () => {
  return useQuery({
    queryKey: ['get-thing-distinct-codes'],
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-thing-distinct-codes', {})
      return data
    }
  })
}
